module.exports = __webpack_public_path__ + "static/media/05-slides.cef5f4ca.png";